/**
 * adempimento-step-fields.ts — F-004 Phase 5 (IMPL-P5-002).
 *
 * ADEMPIMENTO_STEP_FIELDS mappa, per ciascuna variante di adempimento
 * (PROROGA | RISOLUZIONE | CESSIONE), ogni indice di step all'array di
 * field path da passare a `form.trigger()` per la validazione parziale del
 * passo corrente — mirror strutturale di `pratica/lib/step-fields.ts`.
 *
 * Path strategy: string literali tipizzati come
 * `ReadonlyArray<ReadonlyArray<string>>` per evitare import circolari — il tipo
 * `UseFormTrigger` accetta `string[]` senza type errors (identica scelta di
 * `STEP_FIELDS`).
 *
 * Path verificati contro packages/shared/src/schemas/adempimento.ts
 * (varianti pre-refinement):
 *  - common (prefilled): immobile, catastali, locatore, regimeFiscale
 *    (`commonRiferimentoSchema`)
 *  - PROROGA: dataInizioProroga, dataFineProroga, adeguamentoIstat,
 *    nuovoCanoneMensile, nuovoCanoneAnnuale
 *  - RISOLUZIONE: dataRisoluzione, motivo, motivoAltro
 *  - CESSIONE: nuovoInquilino, dataDecorrenza
 */
import type { AdempimentoType } from '@app/shared';

export const ADEMPIMENTO_STEP_FIELDS: Record<
  AdempimentoType,
  ReadonlyArray<ReadonlyArray<string>>
> = {
  PROROGA: [
    // Step 0 — comune (prefilled dalla pratica madre)
    ['immobile', 'catastali', 'locatore', 'regimeFiscale'],
    // Step 1 — delta proroga
    [
      'dataInizioProroga',
      'dataFineProroga',
      'adeguamentoIstat',
      'nuovoCanoneMensile',
      'nuovoCanoneAnnuale',
    ],
  ],
  RISOLUZIONE: [
    // Step 0 — comune (prefilled dalla pratica madre)
    ['immobile', 'catastali', 'locatore', 'regimeFiscale'],
    // Step 1 — delta risoluzione
    ['dataRisoluzione', 'motivo', 'motivoAltro'],
  ],
  CESSIONE: [
    // Step 0 — comune (prefilled dalla pratica madre)
    ['immobile', 'catastali', 'locatore', 'regimeFiscale'],
    // Step 1 — delta cessione
    ['nuovoInquilino', 'dataDecorrenza'],
  ],
} as const;
